import { Check, X } from 'lucide-react';

import { SectionWrapper } from '../../components/SectionWrapper';
import { ruleMay, ruleNever } from './kaiCoachContent';

import styles from './KaiCoachRuleSection.module.css';

export function KaiCoachRuleSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-rule-title"
      background="navy"
      className={styles.root}
      data-testid="kai-coach-section-rule"
    >
      <div className={styles.inner}>
        <p className={styles.kicker}>The one rule</p>
        <h2 className={styles.statement} id="kai-coach-rule-title">
          When a student stalls, Kai Coach <em>may supply the term.</em> It never supplies the
          reasoning.
        </h2>
        <div className={styles.grid}>
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>
              <Check aria-hidden="true" className={styles.iconMay} size={20} />
              Kai Coach may
            </h3>
            <ul className={styles.list}>
              {ruleMay.map((item) => (
                <li className={styles.item} key={item}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>
              <X aria-hidden="true" className={styles.iconNever} size={20} />
              Kai Coach never
            </h3>
            <ul className={styles.list}>
              {ruleNever.map((item) => (
                <li className={`${styles.item} ${styles.itemNever}`} key={item}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <p className={styles.proof}>
          In the History pilot, across <strong>389</strong> instrumented discussion and
          peer-response sessions, <strong>every coach turn contained a question.</strong>
        </p>
      </div>
    </SectionWrapper>
  );
}
